import React, {Suspense} from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./i18n";
import {createStore, applyMiddleware} from "redux";
import {Provider} from "react-redux";
// import allReducers from "./reducers/reducer.index";
import thunk from "redux-thunk";
import {composeWithDevTools} from "@redux-devtools/extension";

import {persistAllReducer} from "./reducers/reducer.index";
import {persistStore} from "redux-persist";
import {PersistGate} from "redux-persist/integration/react";

const middleware = [thunk];

export const store = createStore(
  persistAllReducer,
  composeWithDevTools(applyMiddleware(...middleware))
);
const persistor = persistStore(store);

ReactDOM.render(
  <Provider store={store}>
    <React.StrictMode>
      <Suspense fallback={null}>
        <PersistGate persistor={persistor}>
          <App />
        </PersistGate>
      </Suspense>
    </React.StrictMode>
  </Provider>,
  document.getElementById("root")
);
